<template>
    <div class="filterSegments">
        <div class="filterSegments__content">
            <div class="filterSegments__search">
                <form-input
                    v-model="form.search"
                    :form="form"
                    placeholder="Search segments"
                    autocomplete="off"
                    :focus="true"
                    :error="form.errors.get('search')"
                />
            </div>

            <vue-scroll v-if="filterSegmentsCount" ref="vueScroll" :ops="ops">
                <div class="filterSegments__items">
                    <div class="filterSegments__label">
                        <span> SEGMENTS </span>
                    </div>
                    <div
                        v-for="filterSegment in filtredSegments"
                        v-bind:key="filterSegment.id"
                        class="filterSegments__item"
                        @click="handleChooseSegmentFilter(filterSegment)"
                    >
                        <span>
                            {{ filterSegment.name }}
                        </span>
                        <span @click="handleUpdateSegmentFilter($event, filterSegment)">
                            <fa-icon :icon="['far', 'pencil']" />
                        </span>
                    </div>
                </div>
            </vue-scroll>
            <div v-else class="filterSegments__notFound">Not Found</div>

            <div class="filterSegments__bottom">
                <div class="button is-primary" @click="handleNewSegment($event)">
                    {{ hasModal ? 'New Filter' : 'Search Contacts' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from 'core/Form';

export default {
    emits: ['handleNewSegment', 'handleChooseSegmentFilter', 'handleUpdateSegmentFilter'],
    
    components: {},

    props: {
        filterSegments: { type: Array },
        hasModal: { type: Boolean, default: false },
    },

    data() {
        return {
            form: new Form({
                search: '',
            }),
            ops: {
                vuescroll: {
                    sizeStrategy: 'number',
                },
                scrollPanel: {
                    maxHeight: 180,
                },
                bar: {
                    showDelay: 500,
                    onlyShowBarOnScroll: true,
                    keepShow: true,
                    background: '#7a7a7a',
                    opacity: 1,
                    hoverStyle: false,
                    specifyBorderRadius: false,
                    minSize: 0,
                    size: '6px',
                    disable: false,
                },
            },
        };
    },

    computed: {
        filterSegmentsCount() {
            return this.filtredSegments.length;
        },

        filtredSegments() {
            if (this.form.search) {
                return this.filterSegments.filter((item) => {
                    return item.name.toLowerCase().includes(this.form.search.toLowerCase());
                });
            }

            return this.filterSegments;
        },
    },

    methods: {
        handleNewSegment(e) {
            e.stopPropagation();

            this.$emit('handleNewSegment', e, true);
        },

        handleChooseSegmentFilter(filterSegment) {
            this.$emit('handleChooseSegmentFilter', filterSegment);
        },

        handleUpdateSegmentFilter(e, filterSegment) {
            e.stopPropagation();

            this.$emit('handleUpdateSegmentFilter', filterSegment);
        },
    },
};
</script>
